import React from "react";

function OrderSummary({ orderDetailslist }) {

  return (
    <div className="row">
      <div className="col-lg-5 left_col">
        <div className="sub_box">
          <div className="order_id">
            <h6>Order ID</h6>
            <p>{orderDetailslist?.id}</p>
          </div>
          <div className="shipping_address">
            <h6>Shipping Address</h6>
            <p>
              {orderDetailslist?.shipping_address?.first_name} {orderDetailslist?.shipping_address?.address} <br/>
              {orderDetailslist?.shipping_address?.city_name} {orderDetailslist?.shipping_address?.state_name} - {orderDetailslist?.shipping_address?.pin_code} <br/>
              {orderDetailslist?.shipping_address?.email_id} <br/>
              {orderDetailslist?.shipping_address?.phone_number}
            </p>
          </div>
          <div className="payment_method">
            <h6>Payment ID</h6>
            <p className="mb-0">
              <span>{orderDetailslist?.payment_id}</span>
            </p>
          </div>
        </div>
      </div>
      <div className="col-lg-7 right_col">
        <div className="sub_box">
          <div className="order_id">
            <h6>Order summery </h6>
            <p>
              Cart Value (
              {orderDetailslist?.product_details?.length
                ? `${orderDetailslist.product_details.length} ${
                    orderDetailslist.product_details.length === 1
                      ? "item"
                      : "items"
                  }`
                : "0 items"}
              )
            </p>
          </div>
          <div>
            <table>
              {orderDetailslist?.product_details?.length > 0 ? orderDetailslist.product_details.map((item,index)=>{
                     return(
                      <>
                      <tr key={index}>
                        <td>{item.product_name} ({item.quantity})</td>
                        <td>{item.total_price}</td>
                      </tr>
                     
                      </>
                     )
              }) : null}
               <tr>
                        <td>Shipping Charge </td>
                        <td>{orderDetailslist.shpping_charges}</td>
                      </tr>
                      <tr>
                        <td>
                          <h6>Total</h6>
                        </td>
                        <td>
                          <h6>RM {orderDetailslist.grand_total}</h6>
                        </td>
                      </tr>
            
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderSummary;
